export default "__VITE_ASSET__B_Cutw7P__"